import styled from 'styled-components';
import { TabItem } from './ProductSectionTabTemplate';
import { ProductCommonTitleEn, ProductCommonTitleKR } from './ProductCommons';
import { ItemVideoComponent } from './Molcules/Feature/ItemVideoComponent';
import { ItemImageComponent } from './Molcules/Feature/ItemImageComponent';
import ItemCustomComponent from './Molcules/Feature/ItemCustomComponent';
import AiModelSelection from './Molcules/Feature/AiModelSelection';
import React from 'react';

export interface LocaleObj {
  ko: string;
  en: string;
}
export interface ModelSelection {
  briefText: LocaleObj;
  modelItems: {
    modelPictoImg: string;
    modelName: { ko: string[]; en: string[] };
    modelDesc: LocaleObj;
  }[];
}
export interface FeatureItem {
  featureName: LocaleObj;
  featureText: { ko: string[]; en: string[] };
  vids: string[];
  mobileVids: string[];
  imgs: { src: string; height: number; width: number; blurDataURL: string }[];
  wrapMedia?: boolean;
  artDirection?: boolean;
  link: { label: LocaleObj; href: LocaleObj };
  popup?: { src: string; height: number; width: number; blurDataURL: string }[];
  customComponent?: React.ElementType;
}

interface Props {
  featureItems: {
    featureItems: FeatureItem[];
    aiModelSelection: ModelSelection;
  };
  locale: string;
  pName: TabItem['pathname'];
}

const ProductFeatures = ({ featureItems, locale, pName }: Props) => {
  return (
    <ProductFeaturesContainer>
      <div className="feat-title-wrapper">
        {locale === 'en' ? (
          <ProductCommonTitleEn>Product features</ProductCommonTitleEn>
        ) : (
          <ProductCommonTitleKR>제품 특징</ProductCommonTitleKR>
        )}
      </div>
      {featureItems.featureItems.map(featureItem => (
        <div className="feat-unit-wrapper" key={featureItem.featureName['en']}>
          {/* Todo : featureItem의 component 유형별로 다른 컴포넌트 렌더링 되도록 조건 분기 */}

          {/* 비디오 유형 */}
          {featureItem.vids[0] && (
            <ItemVideoComponent
              videoSrc={featureItem.vids[0]}
              featureTitle={featureItem.featureName[locale]}
              featureDescription={featureItem.featureText[locale]}
            />
          )}

          {/* 사진 유형 */}
          {featureItem.imgs && featureItem.imgs[0] && (
            <ItemImageComponent
              imageSrcArray={featureItem.imgs
                .map(img => img.src)
                .filter(Boolean)}
              featureTitle={featureItem.featureName[locale]}
              featureDescription={featureItem.featureText[locale]}
              artDirection={featureItem.artDirection}
              wrapMedia={featureItem.wrapMedia}
            />
          )}

          {/* 커스텀 유형 */}
          {(((!featureItem.imgs || featureItem.imgs?.length === 0) &&
            (!featureItem.vids || featureItem.vids?.length === 0)) ||
            featureItem.customComponent) && (
            <ItemCustomComponent
              featureTitle={featureItem.featureName[locale]}
              featureDescription={featureItem.featureText[locale]}
              customComponent={featureItem?.customComponent || null}
              locale={locale}
            />
          )}
        </div>
      ))}

      {pName.toLowerCase().includes('sr') && featureItems?.aiModelSelection && (
        <AiModelSelection
          locale={locale}
          aiModelSelection={featureItems.aiModelSelection}
        />
      )}
    </ProductFeaturesContainer>
  );
};

export default ProductFeatures;

export const ProductFeaturesContainer = styled.article`
  width: 100%;
  padding: 96px 0 0;
  .feat-unit-wrapper + .feat-unit-wrapper {
    margin-top: 96px;
  }
  .feat-unit-wrapper:last-child {
    margin-bottom: 146px;
  }
  @media screen and (max-width: 904px) {
    padding: 56px 0 0;
    .feat-unit-wrapper + .feat-unit-wrapper {
      margin-top: 56px;
    }
    .feat-unit-wrapper:last-child {
      margin-bottom: 96px;
    }
  }
  @media screen and (max-width: 599px) {
    padding: 32px 0 0;
    .feat-unit-wrapper:last-child {
      margin-bottom: 56px;
    }
  }
`;
